module.exports = __webpack_public_path__ + "static/img/anli2.ceb4db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/anli2.png
// module id = BjW3
// module chunks = 1